/* Styles */
import '@/scss/main.scss'
import '@mdi/font/css/materialdesignicons.css'
import 'bulma-helpers/css/bulma-helpers.min.css'

/* Core */
import Vue from 'vue'
import Buefy from 'buefy'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VueLazyload from 'vue-lazyload'
import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'

import './vee-validate'
/* Router & Store */
import router from './router'
import store from './store'

/* Service Worker */
import './registerServiceWorker'

/* Vue. Main component */
import App from './App.vue'
import BaseInput from './components/BaseInput.vue'
import format from 'date-fns/format'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['stream']

Sentry.init({
  dsn:
    'https://007eccd55ebc408c880033fe54a55d92@o123170.ingest.sentry.io/5253440',
  integrations: [
    new VueIntegration({ Vue, attachProps: true, logErrors: true })
  ]
})

Vue.use(Buefy, {
  defaultDateFormatter: date => format(date, 'dd/MM/yyyy')
})
Vue.use(VueLazyload)
Vue.use(VueAnalytics, {
  id: 'UA-163688291-1',
  router
})
Vue.use(VueMeta)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('BaseInput', BaseInput)

let routeGuard = async (to, from, next) => {
  const authenticationRequired = to.meta && to.meta.authenticated
  if (authenticationRequired) {
    let authenticated = await store.dispatch('isAuthenticated')
    if (!authenticated) {
      return next({ name: 'Login', query: { redirect: to.path } })
    }
    if (to.meta.verified) {
      let verified = await store.dispatch('isVerified')
      if (!verified) {
        return next({ name: 'VerifyEmail' })
      }
    }
    // if (to.meta.roles) {
    //   let permission = await store.dispatch('hasRole', to.meta.roles)
    //   if (!permission) {
    //     Vue.$buefy.toast.open({
    //       message: 'Permission denied.',
    //       position: 'is-top',
    //       type: 'is-danger'
    //     })
    //     return next(false)
    //   }
    // }
  }
  next()
}

router.beforeEach(routeGuard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
